import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"

const Header = ({ siteTitle }) => (
  <header
    style={{
      background: `steelblue`,
      marginBottom: `1.45rem`,
    }}
  >
    <div
      style={{
        margin: `0 auto`,
        maxWidth: 960,
        padding: `1.45rem 1.0875rem`,
      }}
    >
      <h3 style={{ margin: 0 }}>
        <Link
          to="/"
          style={{
            color: `white`,
            textDecoration: `none`,
          }}
        >
          {siteTitle}
        </Link>


        <Link
          to="/contact"
          style={{
            float: `right`,
            color: `white`,
            textDecoration: `none`,
            marginRight: `10px`
          }}
        >
          Contact
        </Link>

        
        <Link
          to="/posts"
          style={{
            float: `right`,
            color: `white`,
            textDecoration: `none`,
            marginRight: `10px`
          }}
        >
          Posts
        </Link>

        <Link
          to="/"
          style={{
            float: `right`,
            color: `white`,
            textDecoration: `none`,
            marginRight: `10px`
          }}
        >
          Home
        </Link>

      </h3>
    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
